import { GraphQLClient } from 'graphql-request'
import Queries from './graphql/queries'
import Mutations from './graphql/mutations'

const API = '/api/graphql'

function getShop(payload) {
  return new GraphQLClient(API).request(Queries.Shop, payload).then(data => {
    if (data.User && data.Shop.reference.__typename === 'Residential')
      data.Shop.reference.project.roles.shop.salesman = [
        data.User,
        ...data.Shop.reference.project.roles.shop.salesman,
      ] // Override salesman if query param is set

    return data.Shop
  })
}

function selectItem(id, options = {}) {
  let { accessToken, quantity, variant } = options
  return new GraphQLClient(API, {
    headers: {
      authorization: `Basic ${accessToken}`,
    },
  })
    .request(Mutations.ShopSelectItem, { id, quantity, variant })
    .then(data => {
      return data.ShopSelectItem
    })
}

function unselectItem(id, options = {}) {
  let { accessToken } = options
  return new GraphQLClient(API, {
    headers: {
      authorization: `Basic ${accessToken}`,
    },
  })
    .request(Mutations.ShopUnselectItem, { id })
    .then(data => data.ShopUnselectItem)
}

function createLead(data) {
  return new GraphQLClient(API).request(Mutations.LeadCreate, { data }).then(data => data.LeadCrate)
}

export { getShop, selectItem, unselectItem, createLead }
